<template>
    <div>
        <el-card>
            {{ $t('pageNames.forbidden') }}
            <GoHome />
        </el-card>
    </div>
</template>

<script lang="js">
    import { defineComponent } from 'vue';
    import GoHome from '@/components/GoHome.vue'

    export default defineComponent({
        components:{
            GoHome
        },
    });
</script>